<mat-toolbar class="h-100 w-100">

    <div class="d-flex flex-row justify-content-start align-items-center h-100 w-100">

        <!-- Logo -->
        <div class="d-block">
            <a [routerLink]="urlHome">
                <img class="img-fluid logo" [src]="urlLogo">
            </a>
        </div>

        <!-- Menu -->
        <div class="flex-grow-0 flex-md-grow-1"></div>
        <div class="d-none d-lg-block">

            <!-- Participantes -->
            <button mat-button [routerLink]="urlStudents">
                <span class="material-icons me-2">people</span>
                <span class="fs-5">Participantes</span>
            </button>

            <!-- Inscripciones -->
            <button mat-button [routerLink]="urlEnrollments">
                <span class="material-icons me-2">assignment</span>
                <span class="fs-5">Inscripciones</span>
            </button>

            <!-- Mi perfil -->
            <button mat-button [routerLink]="urlProfile">
                <span class="material-icons me-2">manage_accounts</span>
                <span class="fs-5">Mi perfil</span>
            </button>

            <!-- Cerrar sesión -->
            <button mat-button (click)="logout()">
                <span class="material-icons me-2">exit_to_app</span>
                <span class="fs-5">Cerrar sesión</span>
            </button>

        </div>

        <!-- Responsive menu -->
        <div class="flex-grow-1 flex-md-grow-0"></div>
        <div class="d-block d-lg-none">

            <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #mobileMenu="matMenu">

                <!-- Participantes -->
                <button mat-menu-item [routerLink]="urlStudents" class="d-flex flex-row justify-content-start align-items-center custom-header-menu-item">
                    <span class="material-icons me-2">people</span>
                    <span>Participantes</span>
                </button>

                <!-- Inscripciones -->
                <button mat-menu-item [routerLink]="urlEnrollments" class="d-flex flex-row justify-content-start align-items-center custom-header-menu-item">
                    <span class="material-icons me-2">assignment</span>
                    <span>Inscripciones</span>
                </button>

                <!-- Mi perfil -->
                <button mat-menu-item [routerLink]="urlProfile" class="d-flex flex-row justify-content-start align-items-center custom-header-menu-item">
                    <span class="material-icons me-2">manage_accounts</span>
                    <span>Mi perfil</span>
                </button>

                <!-- Cerrar sesión -->
                <button mat-menu-item class="d-flex flex-row justify-content-start align-items-center custom-header-menu-item" (click)="logout()">
                    <span class="material-icons me-2">exit_to_app</span>
                    <span>Cerrar sesión</span>
                </button>

            </mat-menu>

        </div>

	</div>

</mat-toolbar>
